import { useMutation, useQueryClient } from 'react-query';

// Our Axios
import axiosInstance from 'services/API/API';

// Our Endpoints
import { advisorRefreshAllClientDataUrl } from 'shared/api-urls';

// Our QUery keys
import { ERROR_MESSAGE_DATA, SUCCESS_MESSAGE_DATA } from 'shared/query-keys';

function useMutateRefreshAllClientData() {
	const queryClient = useQueryClient();

	return useMutation(
		async () => {
			const response = await axiosInstance.patch(
				advisorRefreshAllClientDataUrl
			);

			const recentTimeStamp = response?.data?.meta?.timestamp;

			return recentTimeStamp;
		},
		{
			onSuccess: () => {
				queryClient.setQueryData(
					SUCCESS_MESSAGE_DATA,
					'Data has been refreshed'
				);
			},
			onError: () => {
				queryClient.setQueryData(
					ERROR_MESSAGE_DATA,
					'Whoops, something went wrong refreshing the data'
				);
			}
		}
	);
}

export default useMutateRefreshAllClientData;
